import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { FormArray, FormGroup } from '@angular/forms';
import {
  AddressFormShape,
  ContactNumberFormShape,
  EmailAddressFormShape,
  SecondaryContactFormShape,
  makeAddressFormGroup,
  makeContactNumberFormGroup,
  makeEmailAddressFormGroup,
  makeSecondaryContactFormGroup,
} from '../patient-form.service';

// Patient-side contact methods: phone numbers, email addresses, physical
// addresses, and secondary contact people. Owns the add/remove UX for each
// FormArray; row-level rendering is delegated to the existing `*FormComponent`
// children. The host form passes in each FormArray and a `validate` flag that
// the secondary-contact rows propagate to their inner controls.
@Component({
  selector: 'app-patient-contact-methods-fieldset',
  templateUrl: './patient-contact-methods-fieldset.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class PatientContactMethodsFieldsetComponent {
  readonly contactNumbers = input.required<FormArray<FormGroup<ContactNumberFormShape>>>();
  readonly emailAddresses = input.required<FormArray<FormGroup<EmailAddressFormShape>>>();
  readonly addressDetails = input.required<FormArray<FormGroup<AddressFormShape>>>();
  readonly secondaryContacts = input.required<FormArray<FormGroup<SecondaryContactFormShape>>>();
  readonly validate = input(false);

  addContactNumber(): void { this.contactNumbers().push(makeContactNumberFormGroup()); }
  removeContactNumber(i: number): void { this.contactNumbers().removeAt(i); }

  addEmailAddress(): void { this.emailAddresses().push(makeEmailAddressFormGroup()); }
  removeEmailAddress(i: number): void { this.emailAddresses().removeAt(i); }

  addAddress(): void { this.addressDetails().push(makeAddressFormGroup()); }
  removeAddress(i: number): void { this.addressDetails().removeAt(i); }

  addSecondaryContact(): void { this.secondaryContacts().push(makeSecondaryContactFormGroup()); }
  removeSecondaryContact(i: number): void { this.secondaryContacts().removeAt(i); }
}
